<template>
  <v-container fluid class="px-0">
    <v-row class="mb-3">
      <v-col cols="12" md="6">
        <el-text-field
          need
          label="Patento registracijos numeris"
          tooltip="Hipoteka. Turtas. Patentas. Patento registracijos numeris"
          :counter="30"
          :readonly="turtasReadonly || !sudarymas"
          v-model="formData.tur_identifikatorius"
          :autofocus="!turtasReadonly && sudarymas"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TurtasPatentas',
  props: {
    formData: Object,
    readonly: Boolean,
    irasomas: Boolean,
    sudarymas: Boolean,
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    turtasReadonly() {
      return this.readonly || !this.irasomas
    },
  },
}
</script>
